<div class="counselling-photo-gallery-dialog">
  <div class="dialog-header">
    <h2 mat-dialog-title>
      <mat-icon>photo_library</mat-icon>
      Counselling Session Documents
    </h2>
    <div class="header-actions" *ngIf="displayedDocuments.length > 0">
      <button mat-raised-button color="accent" *ngIf="!isSelectionMode" (click)="enableSelectionMode()">
        <mat-icon>check_circle</mat-icon>
        Select Images
      </button>
      <button mat-raised-button color="primary" *ngIf="isSelectionMode"
              [disabled]="selectedDocuments.length === 0"
              (click)="confirmSelection()">
        <mat-icon>done</mat-icon>
        Confirm ({{selectedDocuments.length}})
      </button>
      <button mat-button *ngIf="isSelectionMode" (click)="cancelSelection()">
        <mat-icon>cancel</mat-icon>
        Cancel
      </button>
    </div>
  </div>

  <mat-dialog-content class="dialog-content">
    <!-- Filters Section -->
    <div class="filters-section">
      <div class="row">
        <!-- Session Type -->
        <div class="col-md-3">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Session Type</mat-label>
            <mat-select [(ngModel)]="sessionType" (selectionChange)="onSessionTypeChange(sessionType)">
              <mat-option value="individual">Individual Sessions</mat-option>
              <mat-option value="group">Group Sessions</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <!-- Centre Selection -->
        <div class="col-md-3">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Centre</mat-label>
            <mat-select [(ngModel)]="selectedCentre"
                        (selectionChange)="onCentreChange(selectedCentre)"
                        (openedChange)="onCentreSelectOpened($event)">
              <!-- Search Input -->
              <mat-option disabled>
                <input
                  matInput
                  placeholder="Search centres..."
                  (input)="onCentreSearchChange($event)"
                  (click)="$event.stopPropagation()"
                  class="centre-search-input">
              </mat-option>

              <mat-option value="All">All Centres</mat-option>
              <mat-option *ngFor="let centre of filteredCentres" [value]="centre.centreCode">
                {{ centre.centreName }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <!-- Date Range -->
        <div class="col-md-3">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Start Date</mat-label>
            <input matInput [matDatepicker]="startPicker" [(ngModel)]="startDate">
            <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
            <mat-datepicker #startPicker></mat-datepicker>
          </mat-form-field>
        </div>

        <div class="col-md-3">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>End Date</mat-label>
            <input matInput [matDatepicker]="endPicker" [(ngModel)]="endDate">
            <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
            <mat-datepicker #endPicker></mat-datepicker>
          </mat-form-field>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="row">
        <div class="col-md-12 text-right">
          <button mat-raised-button color="primary" (click)="onSearch()" [disabled]="!startDate || !endDate || isLoading">
            <mat-icon>search</mat-icon>
            Search
          </button>
          <button mat-raised-button (click)="onClear()" class="ml-2">
            <mat-icon>clear</mat-icon>
            Clear
          </button>
        </div>
      </div>
    </div>

    <!-- Loading Spinner -->
    <div *ngIf="isLoading" class="loading-container">
      <mat-spinner></mat-spinner>
      <p>Loading documents...</p>
    </div>

    <!-- Results Summary -->
    <div *ngIf="!isLoading && displayedDocuments.length > 0" class="results-summary">
      <div class="summary-info">
        <mat-chip-list>
          <mat-chip color="primary" selected>
            <mat-icon>photo</mat-icon>
            {{ displayedDocuments.length }} Document(s) Found
          </mat-chip>
          <mat-chip *ngIf="selectedImages.length > 0" color="accent" selected>
            <mat-icon>check_circle</mat-icon>
            {{ selectedImages.length }} Selected
          </mat-chip>
          <mat-chip *ngIf="loadDuration > 0">
            <mat-icon>timer</mat-icon>
            Loaded in {{ loadDuration.toFixed(2) }}s
          </mat-chip>
        </mat-chip-list>
      </div>

      <div class="action-buttons">
        <button mat-icon-button (click)="selectAll()" matTooltip="Select All" *ngIf="selectedImages.length === 0">
          <mat-icon>select_all</mat-icon>
        </button>
        <button mat-icon-button (click)="deselectAll()" matTooltip="Deselect All" *ngIf="selectedImages.length > 0">
          <mat-icon>clear</mat-icon>
        </button>
        <button mat-icon-button (click)="downloadAllSelected()" matTooltip="Download Selected" *ngIf="selectedImages.length > 0">
          <mat-icon>cloud_download</mat-icon>
        </button>
        <button mat-icon-button (click)="toggleViewMode()" [matTooltip]="viewMode === 'grid' ? 'Switch to List' : 'Switch to Grid'">
          <mat-icon>{{ viewMode === 'grid' ? 'view_list' : 'view_module' }}</mat-icon>
        </button>
      </div>
    </div>

    <!-- No Results Message -->
    <div *ngIf="!isLoading && displayedDocuments.length === 0 && (startDate && endDate)" class="no-results">
      <mat-icon>image_not_supported</mat-icon>
      <p>No documents found for the selected filters</p>
    </div>

    <!-- Documents Grid/List -->
    <div *ngIf="!isLoading && displayedDocuments.length > 0"
         class="documents-container"
         [class.grid-view]="viewMode === 'grid'"
         [class.list-view]="viewMode === 'list'">
      <mat-card *ngFor="let doc of displayedDocuments"
                class="document-card"
                [class.selected]="isSelected(doc.url)"
                [class.list-item]="viewMode === 'list'">

        <!-- Checkbox Overlay (shown in selection mode) -->
        <div class="selection-checkbox" *ngIf="isSelectionMode">
          <mat-checkbox
            [checked]="isDocumentSelected(doc)"
            (click)="$event.stopPropagation()"
            (change)="toggleDocumentSelection(doc)">
          </mat-checkbox>
        </div>

        <!-- Image/File Preview -->
        <mat-card-content class="document-preview" (click)="selectImage(doc.url)">
          <div class="preview-container">
            <!-- Image Preview -->
            <img *ngIf="isImage(doc.fileName)"
                 [src]="doc.url"
                 [alt]="doc.fileName"
                 class="preview-image"
                 loading="lazy">

            <!-- PDF Preview -->
            <div *ngIf="isPdf(doc.fileName)" class="file-icon-container">
              <mat-icon class="file-icon pdf-icon">picture_as_pdf</mat-icon>
              <p class="file-type-label">PDF</p>
            </div>

            <!-- Other File Types -->
            <div *ngIf="!isImage(doc.fileName) && !isPdf(doc.fileName)" class="file-icon-container">
              <mat-icon class="file-icon">insert_drive_file</mat-icon>
              <p class="file-type-label">FILE</p>
            </div>

            <!-- Selection Overlay -->
            <div class="selection-overlay" *ngIf="isSelected(doc.url)">
              <mat-icon class="check-icon">check_circle</mat-icon>
            </div>
          </div>
        </mat-card-content>

        <!-- Document Info -->
        <mat-card-actions class="document-info">
          <div class="info-row">
            <mat-icon class="info-icon">description</mat-icon>
            <span class="info-text" [matTooltip]="doc.description">{{ doc.description || 'No description' }}</span>
          </div>

          <div class="info-row" *ngIf="doc.centreName">
            <mat-icon class="info-icon">location_on</mat-icon>
            <span class="info-text" [matTooltip]="doc.centreName">{{ doc.centreName }}</span>
          </div>

          <div class="info-row" *ngIf="doc.sessionDate">
            <mat-icon class="info-icon">calendar_today</mat-icon>
            <span class="info-text">{{ getDateString(doc.sessionDate) }}</span>
          </div>

          <!-- Action Buttons -->
          <div class="action-buttons">
            <button mat-icon-button
                    (click)="openImage(doc.url); $event.stopPropagation()"
                    matTooltip="Open in new tab">
              <mat-icon>open_in_new</mat-icon>
            </button>
            <button mat-icon-button
                    (click)="downloadImage(doc.url, doc.fileName); $event.stopPropagation()"
                    matTooltip="Download">
              <mat-icon>download</mat-icon>
            </button>
          </div>
        </mat-card-actions>

        <!-- File Name Footer -->
        <div class="file-name" [matTooltip]="doc.fileName">
          {{ doc.fileName }}
        </div>
      </mat-card>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="dialogRef.close()" *ngIf="!isSelectionMode">
      <mat-icon>close</mat-icon>
      Close
    </button>
    <button mat-button (click)="cancelSelection()" *ngIf="isSelectionMode">
      <mat-icon>cancel</mat-icon>
      Cancel
    </button>
    <button mat-raised-button color="primary"
            (click)="confirmSelection()"
            *ngIf="isSelectionMode"
            [disabled]="selectedDocuments.length === 0">
      <mat-icon>check</mat-icon>
      Confirm Selection ({{ selectedDocuments.length }})
    </button>
  </mat-dialog-actions>
</div>

